import { Store } from 'react-notifications-component';

export const notificationManager = (type, message) => {
  Store.addNotification({
    message: message,
    type: type,
    insert: 'top',
    container: 'top-center',
    animationIn: ['animate__animated', 'animate__fadeIn'],
    animationOut: ['animate__animated', 'animate__fadeOut'],
    dismiss: {
      duration: 3000,
      onScreen: true,
    },
  });
};
